import { useEffect, useRef } from 'react';
import animationMov from 'src/static/animations/chat/bot-avatar.mp4';
import poster from 'src/static/animations/chat/bot-avatar.png';
import animationWebm from 'src/static/animations/chat/bot-avatar.webm';
import './AvatarAnimation.sass';

const AvatarAnimation = () => {
	const ref = useRef<HTMLVideoElement>(null);
	const posterSrc = `${window?._env_?.HOST_URL ?? ''}${poster}`;

	useEffect(() => {
		if (ref && ref.current) {
			ref.current.playbackRate = 0.5;
		}
	}, []);

	return (
		<video className="avatar-animation" disableRemotePlayback autoPlay muted playsInline loop poster={posterSrc} ref={ref}>
			<source src={animationMov} type="video/mp4;codecs=hvc1" />
			<source src={animationWebm} type="video/webm" />
		</video>
	);
};

export default AvatarAnimation;
